var _defs, _path, _g, _path2, _g2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiltersFormat5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3f4f6;\n      }\n\n      .cls-2 {\n        fill: #ffdbb1;\n      }\n\n      .cls-3 {\n        fill: #eceef0;\n      }\n\n      .cls-4 {\n        fill: #b3c1d8;\n      }\n\n      .cls-5 {\n        fill: #d5e7ff;\n      }\n\n      .cls-6 {\n        fill: #2e85ff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,15v16c0,2.21,1.79,4,4,4h32c2.21,0,4-1.79,4-4v-16H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5,
    y: 19,
    width: 10,
    height: 2,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5,
    y: 23,
    width: 10,
    height: 2,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5,
    y: 27,
    width: 7,
    height: 2,
    rx: 1,
    ry: 1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m36,5H4C1.79,5,0,6.79,0,9v6h40v-6c0-2.21-1.79-4-4-4Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 5,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 11,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17,
    cy: 10,
    r: 2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m33.14,28l-2.71-2.71,1.29-1.29c.57-.57.44-1.51-.27-1.82l-8.91-3.49c-.98-.43-1.98.57-1.55,1.55l3.49,8.91c.31.7,1.24.84,1.82.27l1.29-1.29,2.71,2.71c.78.78,2.05.78,2.83,0s.78-2.05,0-2.83Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersFormat5);
export default __webpack_public_path__ + "static/media/filters_format5.34601a42dfd097f6df670bac07b71d99.svg";
export { ForwardRef as ReactComponent };